import Drawer from '@mui/material/Drawer';
import React, { PropsWithChildren } from 'react';

interface DrawerRootProps extends PropsWithChildren {
  open: boolean;
  onClose: () => void;
  backgroundColor: string;
}

export const DrawerRoot: React.FC<DrawerRootProps> = ({
  open,
  onClose,
  backgroundColor,
  children,
}) => {
  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '80vw',
          bgcolor: backgroundColor,
          color: '#fff',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          padding: '16px 8px',
          height: '100dvh',
          boxSizing: 'border-box',
        },
      }}
    >
      {children}
    </Drawer>
  );
};
